<template>
  <div class="step-wrapper">
    <div class="step-item" :class="{active: step === 1}">
      <div class="step-number">
        <span class="step-number-text">1</span>
      </div>
      <div class="step-text">
        <span class="step-text-text">{{$t('message.step1_title')}}</span>
      </div>
    </div>
    <div class="step-arrow">
      <i class="fas fa-angle-right"></i>
    </div>
    <div class="step-item" :class="{active: step === 2}">
      <div class="step-number">
        <span class="step-number-text">2</span>
      </div>
      <div class="step-text">
        <span class="step-text-text">{{$t('message.step2_title')}}</span>
      </div>
    </div>
    <div class="step-arrow">
      <i class="fas fa-angle-right"></i>
    </div>
    <div class="step-item" :class="{active: step === 3}">
      <div class="step-number">
        <span class="step-number-text">3</span>
      </div>
      <div class="step-text">
        <span class="step-text-text">{{$t('message.step3_title')}}</span>
      </div>
    </div>
    <div class="step-arrow">
      <i class="fas fa-angle-right"></i>
    </div>
    <div class="step-item" :class="{active: step === 4}">
      <div class="step-number">
        <span class="step-number-text">4</span>
      </div>
      <div class="step-text">
        <span class="step-text-text">{{$t('message.step4_title')}}</span>
      </div>
    </div>
    <div class="step-arrow">
      <i class="fas fa-angle-right"></i>
    </div>
    <div class="step-item" :class="{active: step === 5}">
      <div class="step-number">
        <span class="step-number-text">5</span>
      </div>
      <div class="step-text">
        <span class="step-text-text">{{$t('message.step5_title')}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MyStep',
  props: {
    step: {
      type: Number,
      default: 1
    }
  }
}
</script>
<style scoped>
</style>
